import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { AxiosError } from 'axios';
import React, { FC, useState } from 'react';
import { AxiosInstance } from '../../utils/callApi';
import { colors } from '../../theme';
import { lighten, Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui';

interface FileViewButtonProps extends ButtonProps {
  url: string;
  label?: string;
  modalTitle?: string;
  pdfId?: string;
  clickHandler?:(summary: {pdfData: string, pdfTitle: string, uniqueId: string, loading: boolean}) => void;
  modalHandler: () => void;
}

const useStyles = makeStyles()((theme: Theme) =>
  ({
    button:{
      color: colors.blue,
      textDecoration: 'none',
      fontWeight: 600,
      backgroundColor: colors.white,
      padding: 5,
      lineHeight: 1,
      width: theme.spacing(10),
      fontSize: 14,
      '&:hover': {
          backgroundColor: lighten(colors.blue, 0.9),
      },
      whiteSpace: 'nowrap',
    }
  }));

const FileViewButton: FC<FileViewButtonProps> = ({
  url,
  label,
  modalTitle,
  pdfId,
  clickHandler,
  modalHandler,
  startIcon,
  ...props
}) => {
  const [error, setError] = useState<AxiosError<{ message: string }> & any>();
  const handleViewPdf = e => {
    modalHandler();
    const run = async () => {
        await AxiosInstance({
            method: 'GET',
            url,
            responseType: 'json',
            timeout: null,
        })
        .then(response => {
            clickHandler({ pdfData: response.data, pdfTitle: modalTitle, uniqueId: pdfId, loading: false });
        })
        .catch(err => setError(err))
    };

    run();
  };
  const {classes} = useStyles();
  if (error) return <div>{error?.message}</div>;

  return (
    <Button
      className={classes.button}
      onClick={handleViewPdf}
      {...props}
    >
      View
    </Button>
  );
};

FileViewButton.defaultProps = {
  label: 'view',
};

export default FileViewButton;
